import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectInShopScanTable(state),
        type: 'in-shop-scan',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryInShopScan,
    changeFilter: action.changeFilterInShopScan,
    toggleSort: action.toggleSortInShopScan,
    toggleMultiSort: action.toggleMultiSortInShopScan,
    gotoPage: action.gotoPageInShopScan,
    initialColumnsVisibility: action.initialTableSettingsInShopScan,
    toggleColumnVisibility: action.toggleColumnVisibilityInShopScan,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/InShopScanSalesOrderSearchContainer.js